<template>
    <van-form  @submit="onSubmit">
        <van-field
                readonly
                clickable
                name="proposal"
                :value="formData.proposal"
                label="报价方案:"
                placeholder="点击选择"
                label-width="100px"
                input-align="left"
                @click="showPicker = true"
                :rules="[{ required: true, message: '请选择报价方案' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="proposals"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"
            />
        </van-popup>
        <van-field
                label="要件清单类型:"
                label-width="100px"
                input-align="left"
                name="accountFlag"
                readonly
                :rules="[{ required: true, message: '请选择要件清单类型' }]"
        >
            <template #input>
                <van-radio-group v-model="formData.accountFlag" direction="horizontal">
                    <van-radio name="个人账户回款">个人账户回款</van-radio>
                    <van-radio name="公户回款">公户回款</van-radio>
                </van-radio-group>
            </template>
        </van-field>
        <van-field v-if="formData.accountFlag=='个人账户回款'"
                readonly
                clickable
                name="personalAccount"
                :value="formData.personalAccount"
                label="个人账户回款:"
                placeholder="点击选择"
                label-width="100px"
                input-align="left"
                :rules="[{ required: true, message: '个人账户回款' }]"
                @click="showPersonalAccount = true"

        />
        <van-popup v-model="showPersonalAccount" position="bottom">
            <van-cell
                    title="已选择"
                    left>
                <template>
                    <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in personalAccountSelected" :key="index" @close="onClose(item)" @click="onClose(item)">{{item}}</van-tag>
                </template>
            </van-cell>

            <van-picker
                    show-toolbar
                    :columns="personalAccounts"
                    @confirm="onPersonalAccountsConfirm"
                    @cancel="showPersonalAccount = false"
                    @change="onPersonalChange"
            />
        </van-popup>
        <van-field v-if="formData.accountFlag=='公户回款'"
                readonly
                clickable
                name="enterpriseAccount"
                :value="formData.enterpriseAccount"
                label="公户回款:"
                placeholder="点击选择"
                label-width="100px"
                input-align="left"
                @click="showEnterpriseAccount = true"
                   :rules="[{ required: true, message: '公户回款' }]"
        />
        <van-popup v-model="showEnterpriseAccount" position="bottom">
            <van-cell
                    title="已选择"
                    left>
                <template>
                    <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in enterpriseAccountSelected" :key="index"  @close="onEnterpriseClose(item)" @click="onEnterpriseClose(item)">{{item}}</van-tag>
                </template>
            </van-cell>

            <van-picker
                    show-toolbar
                    :columns="enterpriseAccounts"
                    @confirm="onEnterpriseAccountsConfirm"
                    @cancel="showEnterpriseAccount = false"
                    @change="onEnterpriseChange"
            />
        </van-popup>

        <van-field
                label="是否配资:"
                label-width="100px"
                input-align="left"
                name="fundingFlag"
                readonly
                :rules="[{ required: true, message: '请选择是否配资' }]"
        >
            <template #input>
                <van-radio-group v-model="formData.fundingFlag" direction="horizontal" @change="onFundingChange">
                    <van-radio name="是">是</van-radio>
                    <van-radio name="否">否</van-radio>
                </van-radio-group>
            </template>
        </van-field>


        <van-field  v-if="formData.fundingFlag=='是'"
                label="配资金额（元）:"
                clickable
                name="fundingAmount"
                :value="formData.fundingAmount"
                @touchstart.native.stop="show = true"
                    :rules="[{ required: true, message: '请输入配资金额' }]"
                readonly
        >
        </van-field>

        <van-number-keyboard
                :show="show"
                extra-key="."
                close-button-text="完成"
                @blur="show = false"
                v-model="formData.fundingAmount"
        />

        <van-field
                label="下户要求:"
                label-width="100px"
                input-align="left"
                name="dueDiligence"
                readonly
                :rules="[{ required: true, message: '请选择下户要求' }]"
        >
            <template #input>
                <van-radio-group v-model="formData.dueDiligence" direction="horizontal">
                    <van-radio name="是">是</van-radio>
                    <van-radio name="否">否</van-radio>
                </van-radio-group>
            </template>
        </van-field>

        <van-field
                label="核行注意事项:"
                placeholder="请输入核行注意事项"
                label-width="100px"
                input-align="left"
                name="attention"
                v-model="formData.attention"
                :rules="[{ required: true, message: '请输入核行注意事项' }]"
        />

        <van-field
                   readonly
                   clickable
                   name="notarization"
                   :value="formData.notarization"
                   label="公证:"
                   placeholder="点击选择"
                   label-width="100px"
                   input-align="left"
                   @click="showNotarization = true"
                   :rules="[{ required: true, message: '请选择公证' }]"
        />
        <van-popup v-model="showNotarization" position="bottom">
            <van-cell
                    title="已选择"
                    left>
                <template>
                    <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in notarizationSelected" :key="index" @close="onNotarizationClose(item)" @click="onNotarizationClose(item)">{{item}}</van-tag>
                </template>
            </van-cell>

            <van-picker
                    show-toolbar
                    :columns="notarizations"
                    @confirm="onNotarizationsConfirm"
                    @cancel="showNotarization = false"
                    @change="onNotarizationChange"
            />
        </van-popup>

        <van-field
                label="其他要求:"
                placeholder="请输入其他要求"
                label-width="100px"
                input-align="left"
                name="other"
                v-model="formData.other"
                :rules="[{ required: true, message: '请输入其他要求' }]"
        />

        <van-field
                    label="预约面谈时间:"
                    clickable
                    :value="formData.appointmentsDate"
                    @touchstart.native.stop="appointmentsDateShow = true"
                    readonly
                    name="appointmentsDate"
                    :rules="[{ required: true, message: '请选择预约面谈时间' }]"
        >
        </van-field>
        <van-calendar v-model="appointmentsDateShow" @confirm="onAppointmentsConfirm" />

        <van-field
                label="预核上家一押:"
                clickable
                :value="formData.checkFirstDate"
                @touchstart.native.stop="checkFirstDateShow = true"
                readonly
                name="checkFirstDate"
                :rules="[{ required: true, message: '请选择预核上家一押时间' }]"
        >
        </van-field>
        <van-calendar v-model="checkFirstDateShow" @confirm="onCheckFirstConfirm" />

        <van-field
                label="预核上家二押:"
                clickable
                :value="formData.checkSecondDate"
                @touchstart.native.stop="checkSecondDateShow = true"
                readonly
                name="checkSecondDate"
                :rules="[{ required: true, message: '请选择预核上家二押' }]"
        >
        </van-field>
        <van-calendar v-model="checkSecondDateShow" @confirm="onCheckSecondConfirm" />

        <van-field
                label="预计核下家:"
                clickable
                :value="formData.checkNextDate"
                @touchstart.native.stop="checkNextDateShow = true"
                readonly
                name="checkNextDate"
                :rules="[{ required: true, message: '请选择预计核下家时间' }]"
        >
        </van-field>
        <van-calendar v-model="checkNextDateShow" @confirm="onCheckNextConfirm" />

        <van-field
                label="预计公证:"
                clickable
                :value="formData.notaryDate"
                name="notaryDate"
                @touchstart.native.stop="notaryDateShow = true"
                readonly
        >
        </van-field>
        <van-calendar v-model="notaryDateShow" @confirm="onNotaryConfirm" />

        <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" :loading="loading">
                保存
            </van-button>
        </div>
    </van-form>
</template>

<script>
    import Vue from 'vue'
    import { Toast } from 'vant'
    Vue.use(Toast)
    import { debounce,cloneDeep } from 'lodash'
    import {ImagePreview} from 'vant'
    import {getForeClousureFileList} from '@/api/loanInfo'
    import {saveFormData,getFormData} from '@/api/foreclosure'
    import icFile from '@/assets/home/ic_file.png'
    export default {
        name: 'risk_first',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                applyInfo:{},
                showPicker:false,
                showPersonalAccount:false,
                showEnterpriseAccount:false,
                showNotarization:false,
                proposals:['标准：（0.07%/日、1.8%/月）','非标准：（0.08%/日、2%/月）'],
                personalAccounts:['身份证原件','户口本原件','结婚证/离婚证/离婚协议/判决书/配偶死亡证明','房产证','银行卡','ukey','手机卡'],
                enterpriseAccounts:['身份证原件','户口本原件','结婚证/离婚证/离婚协议/判决书/配偶死亡证明','营业执照正副本原件','印鉴卡','公章','财务章','法人章','银行卡','操作ukey','审核ukey','手机卡'],
                notarizations:['婚姻公证','财产公证','其他'],
                formData:{},
                personalAccountSelected:[],
                enterpriseAccountSelected:[],
                notarizationSelected:[],
                appointmentsDateShow:false, //面谈时间
                checkFirstDateShow:false, //预计核上家一押时间
                checkSecondDateShow:false, //预计核上家二押时间
                checkNextDateShow:false,//预计核下家时间
                notaryDateShow:false, //预计公证时间
                show:false,
                loading:false,
                list: [
                    {
                        label: '报价方案',
                        ext: 'proposal',
                        info: ''
                    },
                    {
                        label: '要件清单类型',
                        ext: 'accountFlag',
                        info: ''
                    },
                    {
                        label: '要件清单：个人账户回款',
                        ext: 'personalAccount',
                        info: ''
                    },
                    {
                        label: '要件清单：公户回款',
                        ext: 'enterpriseAccount',
                        info: ''
                    },
                    {
                        label: '配资金额',
                        ext: 'fundingAmount',
                        info: ''
                    },
                    {
                        label: '是否配资',
                        ext: 'fundingFlag',
                        info: ''
                    },
                    {
                        label: '下户要求',
                        ext: 'dueDiligence',
                        info: ''
                    },
                    {
                        label: '核行注意事项',
                        ext: 'attention',
                        info: ''
                    },
                    {
                        label: '公证',
                        ext: 'notarization',
                        info: ''
                    },
                    {
                        label: '其他要求',
                        ext: 'other',
                        info: ''
                    },
                    {
                        label: '预约面谈时间',
                        ext: 'appointmentsDate',
                        info: ''
                    },
                    {
                        label: '预计核上家一押',
                        ext: 'checkFirstDate',
                        info: ''
                    },
                    {
                        label: '预计核上家二押',
                        ext: 'checkSecondDate',
                        info: ''
                    },
                    {
                        label: '预计核下家',
                        ext: 'checkNextDate',
                        info: ''
                    },
                    {
                        label: '预计公证',
                        ext: 'notaryDate',
                        info: ''
                    }
                ]


            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            loadData() {
                const self = this
                let params = {
                    applyId: this.applyId,
                    formModule: 'F_RiskFirst'
                }
                getFormData(params).then(res => {
                    let data={}
                    if (res.success) {
                        res.data!=null&&res.data.forEach((item,index)=>{
                            data[item.ext]=item.info
                        })
                        debounce(() => {
                            self.formData=data
                        },200)()
                    }
                })
            },
            //日期格式化
            formatDate(date) {
                var ft=Vue.filter('dateYmdFormat')
                return ft(date)
            },
            //报价方案选择
            onConfirm(value){
                this.formData.proposal = value;
                this.showPicker = false;
            },
            onPersonalAccountsConfirm(value){
                this.formData.personalAccount = this.personalAccountSelected.join(",");
                this.showPersonalAccount = false;
            },
            onEnterpriseAccountsConfirm(value){
                this.formData.enterpriseAccount = this.enterpriseAccountSelected.join(",");
                this.showEnterpriseAccount = false;
            },
            onNotarizationsConfirm(value){
                this.formData.notarization = this.notarizationSelected.join(",");
                this.showNotarization = false;
            },
            onPersonalChange(option,value,index){
                if(!this.personalAccountSelected.includes(value))
                    this.personalAccountSelected.push(value)
            },
            onEnterpriseChange(option,value,index){
                if(!this.enterpriseAccountSelected.includes(value))
                    this.enterpriseAccountSelected.push(value)
            },
            onNotarizationChange(option,value,index){
                if(!this.notarizationSelected.includes(value))
                    this.notarizationSelected.push(value)
            },
            onClose(value){
                if(this.personalAccountSelected.includes(value))
                    this.personalAccountSelected.splice(this.personalAccountSelected.findIndex(item => item===value), 1)
            },
            onEnterpriseClose(value){
                if(this.enterpriseAccountSelected.includes(value))
                    this.enterpriseAccountSelected.splice(this.enterpriseAccountSelected.findIndex(item => item===value), 1)
            },
            onNotarizationClose(value){
                if(this.notarizationSelected.includes(value))
                    this.notarizationSelected.splice(this.notarizationSelected.findIndex(item => item===value), 1)
            },
            //选择预约面谈时间
            onAppointmentsConfirm(date){
                this.appointmentsDateShow = false;
                this.formData.appointmentsDate = this.formatDate(date);
            },
            //预计核上家一押
            onCheckFirstConfirm(date){
                this.checkFirstDateShow = false;
                this.formData.checkFirstDate = this.formatDate(date);
            },
            //预计核下家
            onCheckSecondConfirm(date){
                this.checkSecondDateShow = false;
                this.formData.checkSecondDate = this.formatDate(date);
            },
            //预计核下家
            onCheckNextConfirm(date){
                this.checkNextDateShow = false;
                this.formData.checkNextDate = this.formatDate(date);
            },
            //公证时间
            onNotaryConfirm(date){
                this.notaryDateShow = false;
                this.formData.notaryDate = this.formatDate(date);
            },
            //是否配资
            onFundingChange(value){
                if(value=='否')
                    this.formData.fundingAmount=null
            },
            onSubmit(values){
                let params=cloneDeep(values)
                this.handleParams(params)
                let data={}
                data.applyId = this.applyId
                data.list = this.list
                data.formModule='F_RiskFirst'
                this.loading=true
                saveFormData(data).then(res=>{
                    if(res.success){
                        Toast.success(res.msg);
                    }else{
                        Toast.fail(res.msg);
                    }
                    this.loading=false
                })
            },
            handleParams(params) {
                this.list.forEach((item,index)=>{
                    item.info=params[item.ext]
                })
            }
        }
    }
</script>

<style scoped>

</style>
